import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CognitoService } from '../../services/cognito.service';
import { LabelService } from '../../services/label.service';
import { OutsideClickDirective } from '../../directives/outside-click.directive';
import { HeaderConfig } from '../../shared/types';
import { RoutePersistenceService } from '../../services/route-persistence.service';
import { DashboardNavigationService } from '../../services/dashboard-navigation.service';

@Component({
  selector: 'app-insights-header',
  standalone: true,
  imports: [OutsideClickDirective],
  templateUrl: './insights-header.component.html',
  styleUrls: ['./insights-header.component.scss'],
})
export class InsightsHeaderComponent {
  @Input() config: HeaderConfig = {
    title: '',
  };
  showDropdown: boolean = false;

  constructor(
    private router: Router,
    private cognitoService: CognitoService,
    public labelService: LabelService,
    private location: Location,
    private routePersistenceService: RoutePersistenceService,
    private dashboardNavigationService: DashboardNavigationService
  ) {}

  clickLogout() {
    this.router.navigate(['login']);
    this.showDropdown = false;
    localStorage.clear();
    try {
      sessionStorage.clear(); // Clear Insights Dashboard session state (route, filters, selection, cache)
    } catch (e) {
      // ignore
    }
    this.routePersistenceService.clearSavedRoute();
    this.cognitoService.deleteCookies();
    this.cognitoService.clearCookies();
    localStorage.removeItem('authToken');
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  onOutsideClick = () => {
    this.showDropdown = false;
  };

  toggleNova() {
    this.router.navigate(['/nova']);
  }

  handleBackPress() {
    const currentPath = this.router.url;

    // If on create-dashboard route, check if chart form is open or in edit mode
    if (currentPath.includes('/create-dashboard')) {
      // Always emit back button click to let create-dashboard component handle it
      // This will trigger the canDeactivate guard if there are unsaved changes
      this.dashboardNavigationService.emitBackButtonClick();
    } else if (currentPath.includes('/user-dashboard')) {
      // If on user-dashboard route, navigate to conversation-insights (default dashboard)
      this.router.navigate(['/conversation-insights']);
    } else {
      // Use location.back() for other routes
      this.location.back();
    }
  }
}
